import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useFiltersStore } from "@/store/SerpPage/FiltersStore";

export default /*@__PURE__*/_defineComponent({
  __name: 'CloseButton',
  setup(__props) {

const filtersStore = useFiltersStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "serp__filters--mobile-close-button",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(filtersStore).hideFiltersOnMobile && _unref(filtersStore).hideFiltersOnMobile(...args))),
    "aria-label": "Zamknij filtry"
  }, _cache[1] || (_cache[1] = [
    _createElementVNode("span", { class: "q-close-icon" }, null, -1)
  ])))
}
}

})